export enum IgniteSnackbarType {
  Success,
  Alert,
  Info,
}
